// extracted by mini-css-extract-plugin
export default {"layout_grid_select_header":"style_layout_grid_select_header__OguEF"};